import { ChangeDetectionStrategy, Component } from '@angular/core';

import { FormManagerService } from '@sim/form';
import { BaseFiltersComponent, FilterFieldsOptions } from '@ui/ui.module';

import { SourceBibliographicFilter, SourceBibliographicFilterMeta } from '@atmi/core/models';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-source-bibliographic-filters',
  styleUrls: ['./source-bibliographic-filters.component.scss'],
  templateUrl: './source-bibliographic-filters.component.html',
})
export class SourceBibliographicFiltersComponent
  extends BaseFiltersComponent<SourceBibliographicFilter, FilterFieldsOptions<SourceBibliographicFilter>> {

  constructor(
    protected readonly formManager: FormManagerService,
  ) {
    super(formManager, SourceBibliographicFilterMeta);
  }

}
